import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import * as Sentry from "@sentry/vue";

import store from '@/store/'
import router from '@/router/'
import * as keys from '@/router/router-keys'

import { MessageBox, Message } from 'element-ui'

const Qs = require('query-string')

Vue.use(VueAxios, axios)

axios.defaults.paramsSerializer = (params) => {
  return Qs.stringify(params, { arrayFormat: 'bracket' })
}

var countErrors = 0
// Response interceptor
axios.interceptors.response.use(
  function (response) {
    // console.log('--> axios response interceptor:', response)
    const { status, data } = response

    // show response message/Laravel
    // `silentMessages: true` in the request config opts out: the caller shows its own feedback
    if (!response.config.silentMessages && typeof data.message !== 'undefined' && typeof data['message-type'] !== 'undefined') {
      Message({
        dangerouslyUseHTMLString: true,
        message: data.message,
        type: data['message-type'],
        duration: 3000,
        showClose: true,
      })
    }

    // update store/auth/timestamp for every successful ajax request
    if (status === 200 && response.config.url !== '/api/auth/refresh') {
      store.commit('auth/AUTH_TIMESTAMP')
    }

    // check for global message and put it in state
    if (data.global_message) {
      store.commit('user/SET_GLOBAL_MESSAGE', data.global_message)
    }

    return response
  },
  function (error) {
    Sentry.addBreadcrumb({
      category: 'axios-interceptor',
      message: 'Entering error interceptor',
      data: {
        fullError: error,
        hasResponse: !!error.response,
        url: error.config?.url,
        method: error.config?.method
      },
      level: 'error'
    });

    if (axios.isCancel(error)) {
      return Promise.reject(error)
    }

    if (!error.response) {
      Sentry.addBreadcrumb({
        category: 'axios-interceptor',
        message: 'No error.response present',
        level: 'error'
      });
      return Promise.reject(error)
    }

    const { status, statusText } = error.response

    // PD-4972: the API requires the CSRF token on session writes. A missing or
    // stale XSRF-TOKEN cookie gets a 419 with error=csrf_token_mismatch and a
    // fresh cookie, so retry the request once before showing anything.
    if (status === 419 && error.response.data && error.response.data.error === 'csrf_token_mismatch' && !error.config._csrfRetried) {
      return axios({ ...error.config, _csrfRetried: true })
    }

    let isMessageShown = false
    // show response message/Laravel
    if (
      !error.config.silentMessages &&
      typeof error.response.data.message !== 'undefined' &&
      [200, 422, 400, 401, 403, 429, 413].includes(status)
    ) {
      if (error.response.data.message && !isMessageShown) {
        store.commit('app/SET_ERROR', true)

        countErrors++
        isMessageShown = true

        if (
          status === 429 &&
          typeof error.response.data.errors !== 'undefined' &&
          typeof error.response.data.errors.email !== 'undefined'
        ) {
          error.response.data.message = error.response.data.errors.email[0]
        }

        Message({
          dangerouslyUseHTMLString: true,
          message: error.response.data.message,
          type: 'error',
          duration: 3500,
          showClose: true,
          onClose: () => {
            countErrors--

            if (countErrors === 0) {
              store.commit('app/SET_ERROR', false)
            }
          },
        })
      }
      if (status === 422 || status === 429) {
        store.dispatch('CANCEL_PENDING_REQUESTS')
      }
    }

    // handle server errors
    if (status >= 500 && !isMessageShown) {
      const data = error.response.data
      store.dispatch('CANCEL_PENDING_REQUESTS')

      if (data.message && data.title) {
        isMessageShown = true

        MessageBox.alert(error.response.data.message, error.response.data.title, {
          confirmButtonText: 'OK',
        })
      }
    }

    // handle 404 errors
    // if (status === 404) {
    //   store.dispatch('CANCEL_PENDING_REQUESTS')
    //   router.push({ name: 'NotFound' })
    // }

    // handle unauthorized/session expired errors
    if (status === 401) {
      // a session that was live has ended: the login page tells the user why they are back
      if (store.getters['auth/is_auth'] && error.response.config.url !== '/api/auth/logout') {
        sessionStorage.setItem(keys.LS_SESSION_EXPIRED_NOTICE, JSON.stringify(true))
      }
      if (error.response.config.url !== '/api/auth/logout' && router.currentRoute.name !== 'login') {
        store.dispatch('RESET_STORE_DATA', {}, { root: true })
        //store.dispatch('auth/LOGOUT')
      }
      store.commit('auth/AUTH_TIMESTAMP')
      window.location.href = '/login'
    }

    // handle 419/ expired token errors
    if (status === 419 && !isMessageShown) {
      const { data } = error.response
      isMessageShown = true

      MessageBox.alert(!data ? statusText : data.message, 'Error ' + status, {
        confirmButtonText: 'OK',
        callback: () => {
          location.reload()
        },
      })
    }

    return Promise.reject(error)
  }
)

axios.interceptors.request.use(
  function (config) {
    //  Generate cancel token source
    const source = axios.CancelToken.source()

    // Set cancel token on this request
    config.cancelToken = source.token

    // Add to vuex to make cancellation available from anywhere
    store.commit('ADD_CANCEL_TOKEN', source)

    return config
  },
  function (error) {
    return Promise.reject(error)
  }
)
